export { default } from './KeyValueTooltip.component';
export type { KeyValueTooltipProps, TooltipEntry } from './KeyValueTooltip.component';
